import { SUGGESTIONS_REQUESTED } from "./const";

function action() {
  return {
    type: SUGGESTIONS_REQUESTED,
  };
}

export default action;
